import moment from 'moment'
import * as React from 'react'

interface Props {
    className: string
    countdownEnd: moment.Moment
    refreshMs: number
    onComplete?: any
    children?: React.ReactNode
}

class Countdown extends React.Component<Props> {
    public static defaultProps = {
        refreshMs: 5000,
    }
    private interval: number

    public constructor(props) {
        super(props)

        this.state = {
            lastRun: moment.utc(),
        }
    }

    public componentDidMount(): void {
        this.interval = window.setInterval(() => this.setState({ lastRun: moment.utc() }), this.props.refreshMs)
    }

    public componentWillUnmount(): void {
        window.clearInterval(this.interval)
    }

    public render(): React.ReactNode {
        const { countdownEnd, className, children, onComplete } = this.props

        const countdownFinished = moment.utc() > countdownEnd

        if (onComplete && countdownFinished) {
            onComplete()
        }

        const timeLeft = countdownFinished
            ? 'ended ' + moment.utc().to(countdownEnd, true) + ' ago'
            : moment.utc().to(countdownEnd, true) + ' left'

        const title = countdownEnd.isSame(moment().utc(), 'day')
            ? 'ends at ' + countdownEnd.local().format('HH:mm ZZ')
            : 'ends at ' + countdownEnd.local().format('YYYY-MM-DD HH:mm ZZ')

        return (
            <span className={className} title={title}>
                {children} {timeLeft}
            </span>
        )
    }
}

export default Countdown
